<template>
  <div class="content">
    <div class="title-text">
      <p class="title">iTunes Affiliate Token</p>
    </div>
    <div class="content-body">
      <div class="edit-card">
        <div class="card-content">
          <div class="inputs">
            <div class="affiliate-token">
              <label>
                <span class="label">iTunes Affiliate Token</span>
                <input
                  v-model="itunes_affiliate_id"
                  type="text"
                  placeholder="Please enter your iTunes Affiliate Token"
                />
              </label>
            </div>
          </div>
          <button @click="updateItunesAffiliateId" class="button-default">
            <span>Update</span>
          </button>
        </div>
      </div>
    </div>
    <SnackBar />
  </div>
</template>

<script>
import {
  Q_ITUNES_AFFILIATE_ID,
  M_UPDATE_ITUNES_AFFILIATE_ID
} from "@/graphql";
import "@/assets/scss/custom/vendors-extensions/_sweetalert.scss";
import SnackBar from "@/components/Custom/SnackBar";
export default {
  name: "ItunesAffiliateToken",
  components: {
    SnackBar,
  },
  data() {
    return {
      itunes_affiliate_id: null
    };
  },
  watch: {
    user() {
      this.itunes_affiliate_id = this.user.itunes_affiliate_id;
    },
  },
  apollo: {
    user: {
      query: Q_ITUNES_AFFILIATE_ID,
      variables() {
        return {
          id: this.$store.getters.getUser.id
        };
      },
    }
  },
  methods: {
    async updateItunesAffiliateId() {
      try {
        await this.$apollo.mutate({
          mutation: M_UPDATE_ITUNES_AFFILIATE_ID,
          variables: {
            id: this.$store.getters.getUser.id,
            itunes_affiliate_id: this.itunes_affiliate_id
          },
        });

        await this.$store.dispatch("snack", {
          text: "Success! iTunes Affiliate Token updated",
        });
      } catch (e) {
        await this.$store.dispatch("snack", {
          type: "error",
          text: `Oops! ${e.message.replace("GraphQL error: ", "")}`,
        });
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.edit-card {
  padding: 0 24px 24px;
  /* BG/type2 */
  background: $bg-type-2;
  /* Shadow */
  box-shadow: 0px 50px 40px rgba(23, 18, 43, 0.3);
  border-radius: 10px;
  .card-top {
    .card-title {
      /* 18/SemiBold */
      font-weight: 600;
      font-size: 18px;
      line-height: 30px;
      /* White */
      color: white;
      mix-blend-mode: normal;
      opacity: 0.9;
    }
    .card-text {
      margin: 0;
      font-size: 14px;
      line-height: 24px;
      /* Text/type0 */
      color: $text-type-0;
      mix-blend-mode: normal;
      opacity: 0.9;
    }
  }
  .card-content {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    .inputs {
      margin-top: 24px;
      width: 100%;
      //display: flex;
      display: grid;

      label {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        align-items: baseline;
        .label {
          margin-left: 11px;
          width: 100%;
          /* 12/Bold */
          font-weight: bold;
          font-size: 12px;
          line-height: 15px;
          /* Text/type1 */
          color: $text-type-1;
        }
        input {
          margin-top: 6px;
          padding: 13px 11px;
          //width: 100%;
          flex: 1;
          /* Purple-dark */
          background: $purple-dark;
          /* Purple-stroke */
          border: 1px solid $purple-stroke;
          box-sizing: border-box;
          border-radius: 5px;
          outline: none;
          //border: none;
          color: $text-type-0;
          /* 14/Regular */
          font-size: 14px;
          line-height: 17px;
          &:focus {
            outline: none;
            //border: 1px solid $purple;
          }
          &::placeholder {
            color: $text-type-2;
            /* 14/Regular */
            font-size: 14px;
            line-height: 17px;
          }
        }
      }
    }
    button {
      margin-top: 18px;
      padding: 9px 30px;
      &:disabled {
        cursor: not-allowed;
        opacity: 0.5;
      }
    }
  }
}
</style>
